import { infoFetchGetTituloI, makeTitulo } from "dtos/titulo";
import {
  FetchCallbackI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { ENDPOINTS } from "./endpoints";
import { servicesUtils } from "./utils/services.utils";

export const getTitulos = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFetchGetTituloI>
  >({
    method: "GET",
    uri: ENDPOINTS.TITULOS,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  const elementosFormated = response.elementos.map((ctElemento) =>
    makeTitulo(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const postTitulo = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetTituloI>({
    method: "POST",
    uri: ENDPOINTS.TITULOS,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeTitulo(response);
};

export const putTitulo = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetTituloI>({
    method: "PUT",
    uri: ENDPOINTS.TITULOS,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeTitulo(response);
};

export const deleteTitulo = async (id: any) => {
  const response = await sendRequest<infoFetchGetTituloI>({
    method: "DELETE",
    uri: ENDPOINTS.TITULOS + "/" + id,
  });
  return makeTitulo(response);
};
